import { List } from "../base/List";
import VisibilityEntityListItem from "./VisibilityEntityListItem";

import { useCesiumContext } from "../cesium/CesiumContext";

type VisibilityEntityListProps = {
    trackingViewers: [string | undefined, string][];
    removeItem: (entityId: [string | undefined, string]) => void;
}
export default function VisibilityEntityList({
    trackingViewers = [],
    removeItem
}: VisibilityEntityListProps) {
    const { map } = useCesiumContext();
    return (
        <div className="flex-1 overflow-y-auto">
            <List>
                {trackingViewers.map((entityId) =>
                    <VisibilityEntityListItem entityId={entityId} removeItem={removeItem}/>
                )}
            </List>
        </div>
    );
}
